import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#05050A] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass-card rounded-3xl p-10 text-center max-w-md w-full">
        <XCircle className="w-16 h-16 text-[#FF007F] mx-auto mb-6" />
        <h2 className="font-['Unbounded'] text-2xl font-bold text-white mb-2">{t("pay_cancel_title")}</h2>
        <p className="text-[#A0A0AB] text-sm mb-6">{t("pay_cancel_text")}</p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Link to="/marketplace" className="neon-btn text-sm py-2 px-6">{t("pay_back_market")}</Link>
          <Link to="/" className="neon-btn neon-btn-pink text-sm py-2 px-6">{t("pay_home")}</Link>
        </div>
      </motion.div>
    </div>
  );
}
